import { TFunction } from 'i18next';

const optionsT = 'surchargesMaintenance.form.methodOptions';

export const getMethodOptions = (t: TFunction) => [
  { value: '0', label: t(optionsT + '.method0') },
  { value: '1', label: t(optionsT + '.method1') },
  { value: '2', label: t(optionsT + '.method2') }
];
